/* src/app/admin/audit-log/audit-log-result/audit-log-result.component.scss */
/*# sourceMappingURL=audit-log-result.component-OK25EAPI.css.map */
